import React, { useState, useEffect, useMemo } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";
// YENİ: useNavigate EKLENDİ
import { Link, useNavigate } from "react-router-dom";

function formatCurrency(n) {
  if (typeof n !== "number") return "---";
  return n.toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
  });
}

export default function GelecekAylar() {
  const navigate = useNavigate(); // Yönlendirme kancası
  const [gelirler, setGelirler] = useState([]);
  const [seciliAy, setSeciliAy] = useState(null);

  // ➕ TARİH – SAAT
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const ayIsimleri = [
    "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
    "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
  ];

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "taksitler"), (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setGelirler(arr);
    });
    return () => unsub();
  }, []);

  const aylik = useMemo(() => {
    const map = {};

    gelirler
      .filter((t) => t.durum !== "Ödendi")
      .forEach((t) => {
        const d = t.odemeGunu.toDate();
        const key = `${d.getFullYear()}-${d.getMonth() + 1}`;

        if (!map[key]) {
          map[key] = {
            yil: d.getFullYear(),
            ay: d.getMonth() + 1,
            toplam: 0,
            detay: [],
          };
        }

        map[key].toplam += t.miktar;
        map[key].detay.push(t);
      });

    return Object.values(map).sort((a, b) =>
      a.yil === b.yil ? a.ay - b.ay : a.yil - b.yil
    );
  }, [gelirler]);

  return (
    <div className="admin-page">
      
      {/* 🔥 ÜST PATRON PANELİ TASARIMI */}
      <div className="admin-header">
        
        {/* --- YENİ: Tıklanabilir Logo Alanı --- */}
        <h1 
            className="brand-logo admin-brand-header"
            onClick={() => navigate('/patron/dashboard')}
            style={{ cursor: 'pointer' }}
            title="Patron Paneline Dön"
        >
          <img
            src="/logo.png"
            alt="logo"
            width="50"
          />
          ARAS ASAF İNŞAAT – GELECEK AYLIK ÖDEMELER
        </h1>

        <div className="date-time-info">
          {now.toLocaleDateString("tr-TR")} |{" "}
          {now.toLocaleTimeString("tr-TR")}
        </div>

        <Link
          to="/patron/dashboard"
          className="admin-button-secondary small"
        >
          ← Patron Paneli
        </Link>
      </div>

      <h1 style={{ color: "#D4AF37" }}>Gelecek Aylardaki Paralar</h1>

      {/* AY LİSTESİ */}
      {!seciliAy && (
        <table className="admin-table" style={{ marginTop: 15 }}>
          <thead>
            <tr>
              <th>Ay</th>
              <th>Gelecek Para</th>
              <th>Detay</th>
            </tr>
          </thead>

          <tbody>
            {aylik.map((a, i) => (
              <tr key={i}>
                <td>{ayIsimleri[a.ay - 1]} {a.yil}</td>
                <td>{formatCurrency(a.toplam)}</td>
                <td>
                  <button
                    className="admin-button small"
                    onClick={() => setSeciliAy(a)}
                  >
                    Görüntüle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* AY DETAY */}
      {seciliAy && (
        <>
          <h2 style={{ marginTop: 20 }}>
            {ayIsimleri[seciliAy.ay - 1]} {seciliAy.yil} – Müşteri Detayları
          </h2>

          <table className="admin-table" style={{ marginTop: 10 }}>
            <thead>
              <tr>
                <th>Müşteri</th>
                <th>Ödeme Tarihi</th>
                <th>Tutar</th>
              </tr>
            </thead>

            <tbody>
              {seciliAy.detay.map((t, index) => (
                <tr key={index}>
                  <td>{t.cariAd}</td>
                  <td>{t.odemeGunu.toDate().toLocaleDateString("tr-TR")}</td>
                  <td>{formatCurrency(t.miktar)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <button
            className="admin-button-secondary"
            style={{ marginTop: 20 }}
            onClick={() => setSeciliAy(null)}
          >
            ← Ay Listesine Dön
          </button>
        </>
      )}
    </div>
  );
}